export interface PaginatedResponse<T> {
  items: T[]
  count: number
  pageCount: number
}

export interface PaginationVars {
  page?: number
  perPage?: number
}

export const DEFAULT_PER_PAGE = 200
export const TABLE_PER_PAGE = 10
export const BLOCK_PER_PAGE = 10

export const DEFAULT_PAGE = 1

export const LIST_MAX_MESSAGE = '登録できる最大数は200件です'
